import {SET_LOADING_SPINNER_PROGRESS, SET_LOADING_SPINNER_OPEN, SET_LOADING_SPINNER_TYPE, SET_LOADING_SPINNER_MESSAGE} from "../actions/loadingSpinner";
const initialState = {
    loadingSpinnerOpen: false,
    loadingSpinnerProgress: 0,
    loadingSpinnerMessage: ''
};

export default function loadingSpinnerReducer(state = initialState, action) {
    switch (action.type) {
        case SET_LOADING_SPINNER_MESSAGE:
            return {
                ...state,
                loadingSpinnerMessage: action.spinnerMessage,
            };
        case SET_LOADING_SPINNER_PROGRESS:
            return {
                ...state,
                loadingSpinnerProgress: action.percent,
            };
        case SET_LOADING_SPINNER_OPEN:
            return {
                ...state,
                loadingSpinnerOpen: action.open,
            };
        case SET_LOADING_SPINNER_TYPE:
            return {
                ...state,
                loadingSpinnerType: action.spinnerType,
            };
        default:
            return state;
    }
}